// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__4TXNT","closeButton":"modal_closeButton__DsCEZ"};